import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ changedValue, allData }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Year",
        },
        ticks: {
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Amount (USD)",
        },
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
      },
    },
  };
  const generateRandomArray = (length, min, max) => {
    const arr = [];
    for (let i = 0; i < length; i++) {
      arr.push(Math.floor(Math.random() * (max - min + 1)) + min);
    }
    return arr;
  };
  const [data, setData] = useState({
    labels: [
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
      "2033",
      "2034",
      "2035",
    ],
    datasets: [
      {
        label: "Amount($)",
        data: generateRandomArray(11, 5000, 6000),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(75, 192, 192, 0.9)",
      },
    ],
  });
  useEffect(() => {
    const data = allData.map((item) => item.CAPEX);
    const year = allData.map((item) => item.Year);
    setData({
      labels: year,
      datasets: [
        {
          label: "Amount($)",
          data: data,
          borderColor: themeColor,
          backgroundColor: colors[changedValue % colors.length],
        },
      ],
    });
  }, [allData]);
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];

  return data ? (
    <div style={{ position: "relative", height: "184px", width: "100%" }}>
      <Line options={options} data={data} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
